import {default as AuthStore} from "./AuthStore";
import UserStore from "./UserStore";
import GroupStore from "./GroupStore";
import CommonStore from "./CommonStore";
import NavigateStore from "./NavigateStore";
import ContentStore from "./ContentStore";
import SummaryContentStore from "./SummaryContentStore";
import DialogStore from "./DialogStore";
import ExcelStore from "./ExcelStore";
import OddStepOneStore from "./OddStepOneStore";
import OddStepTwoStore from "./OddStepTwoStore";
import OddStepThreeStore from "./OddStepThreeStore";
import OddStepFourStore from "./OddStepFourStore";
import OddStepFiveStore from "./OddStepFiveStore";
import OddStepSixStore from "./OddStepSixStore";
import OddStepSevenStore from "./OddStepSevenStore";
import AudioPlayerStore from "./AudioPlayerStore";
import EvenStepOneStore from "./EvenStepOneStore";
import EvenStepTwoStore from "./EvenStepTwoStore";
import EvenStepFourStore from "./EvenStepFourStore";
import EvenStepFiveStore from "./EvenStepFiveStore";
import EvenStepSixStore from "./EvenStepSixStore";
import EvenStepSevenStore from "./EvenStepSevenStore";
import EvenStepThreeStore from "./EvenStepThreeStore";
import LocaleStore from "./LocaleStore";
import StatisticsStore from "./StatisticsStore";
import NoticeStore from "./NoticeStore";
import FAQStore from "./FAQStore";
import PushStore from "./PushStore";

import AuthRepository from "../repositories/AuthRepository";
import UserRepository from "../repositories/UserRepository";
import GroupRepository from "../repositories/GroupRepository";
import ContentRepository from "../repositories/ContentRepository";
import AiRepository from "../repositories/AiRepository";
import UserStudyRepository from "../repositories/UserStudyRepository";
import FAQRepository from "../repositories/FAQRepository";
import NotificationRepository from "../repositories/NotificationRepository";
import PushRepository from "../repositories/PushRepository";


const authRepository = new AuthRepository();
const userRepository = new UserRepository();
const groupRepository = new GroupRepository();
const contentRepository = new ContentRepository();
const aiRepository = new AiRepository();
const userStudyRepository = new UserStudyRepository();
const faqRepository = new FAQRepository();
const notificationRepository = new NotificationRepository();
const pushRepository = new PushRepository();

const commonStore = new CommonStore();
const dialogStore = new DialogStore();
const contentStore = new ContentStore({contentRepository, aiRepository, dialogStore, commonStore});
const localeStore = new LocaleStore();
const groupStore = new GroupStore({groupRepository, dialogStore, commonStore});

export const stores = {
    authStore: new AuthStore({authRepository, dialogStore}),
    userStore: new UserStore({userRepository, dialogStore, commonStore}),
    groupStore: new GroupStore({groupRepository, dialogStore, commonStore}),
    commonStore: commonStore,
    navigateStore: new NavigateStore(),
    contentStore: contentStore,
    summaryContentStore: new SummaryContentStore({contentRepository, commonStore}),
    excelStore: new ExcelStore({contentRepository, dialogStore, commonStore}),
    oddStepOneStore: new OddStepOneStore({contentRepository, contentStore, dialogStore, commonStore}),
    oddStepTwoStore: new OddStepTwoStore({contentRepository, contentStore, dialogStore, commonStore}),
    oddStepThreeStore: new OddStepThreeStore({contentRepository, contentStore, dialogStore, commonStore}),
    oddStepFourStore: new OddStepFourStore({contentRepository, contentStore, dialogStore, commonStore}),
    oddStepFiveStore: new OddStepFiveStore({contentRepository, contentStore, dialogStore, commonStore}),
    oddStepSixStore: new OddStepSixStore({contentRepository, contentStore, dialogStore, commonStore}),
    oddStepSevenStore: new OddStepSevenStore({contentRepository, contentStore, dialogStore, commonStore}),
    evenStepOneStore: new EvenStepOneStore({contentRepository, contentStore, dialogStore, commonStore}),
    evenStepTwoStore: new EvenStepTwoStore({contentRepository, contentStore, dialogStore, commonStore}),
    evenStepThreeStore: new EvenStepThreeStore({contentRepository, contentStore, dialogStore, commonStore}),
    evenStepFourStore: new EvenStepFourStore({contentRepository, contentStore, dialogStore, commonStore}),
    evenStepFiveStore: new EvenStepFiveStore({contentRepository, contentStore, dialogStore, commonStore}),
    evenStepSixStore: new EvenStepSixStore({contentRepository, contentStore, dialogStore, commonStore}),
    evenStepSevenStore: new EvenStepSevenStore({contentRepository, contentStore, dialogStore, commonStore}),
    faqStore: new FAQStore({faqRepository, dialogStore, commonStore}),
    dialogStore: dialogStore,
    audioPlayerStore: new AudioPlayerStore(),
    localeStore: new LocaleStore(),
    statisticsStore: new StatisticsStore({userStudyRepository}),
    noticeStore: new NoticeStore({notificationRepository, dialogStore, commonStore, localeStore, groupStore}),
    pushStore: new PushStore({commonStore, pushRepository, localeStore, dialogStore}),
};
